import { addDays, format, parseISO } from 'date-fns';
import { DateRange } from 'src/pages/TruckShifts/truckShiftGrid';

export type CopyRequestBody = {
  truck_ids: number[];
  source_start_on: string;
  source_end_on: string;
  target_start_on: string;
};

const WEEKDAY_JA = ['日', '月', '火', '水', '木', '金', '土'];

// 表示中の週（target）に対する「前週」（source）。両端を 7 日前にずらす。
// 週表示前提：target は 7 日・offset 7 なので API の target 範囲は表示中の週ぴったり。
export const previousWeekRange = (current: DateRange): DateRange => ({
  startOn: format(addDays(parseISO(current.startOn), -7), 'yyyy-MM-dd'),
  endOn: format(addDays(parseISO(current.endOn), -7), 'yyyy-MM-dd'),
});

export const buildCopyRequest = (args: {
  truckIds: number[];
  source: DateRange;
  targetStartOn: string;
}): CopyRequestBody => ({
  truck_ids: args.truckIds,
  source_start_on: args.source.startOn,
  source_end_on: args.source.endOn,
  target_start_on: args.targetStartOn,
});

// コピー先（＝表示中の週）の既存勤務数＝上書きされる件数。
export const countExistingShifts = (trucks: { shifts: unknown[] }[]): number =>
  trucks.reduce((n, t) => n + t.shifts.length, 0);

export const formatRangeLabel = (range: DateRange): string => {
  const label = (iso: string): string => {
    const d = parseISO(iso);
    return `${d.getMonth() + 1}/${d.getDate()}(${WEEKDAY_JA[d.getDay()]})`;
  };
  return `${label(range.startOn)} 〜 ${label(range.endOn)}`;
};
